import { lazyLoad } from "../../../../utils/loadable.js";

export const MyDocuments = lazyLoad(
    () => import("./index.js"),
    (module) => module.MyDocuments,
);
